import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import '../assets/css/wordmatch.css';
import Sidebar from '../components/Sidebar';
import GameMenu from '../components/GameMenu';
import Timer from '../components/Timer';
import Popup from '../components/Popup';
import LeaveGamePopup from '../components/LeaveGamePopup';
import EndGameBtn from "../components/EndGameBtn";
import AnimatedBg from "../components/AnimatedBg";

export default function WordMatch() {
  const location = useLocation();
  const { theme, subTheme, level = 2 } = location.state || {};

  const [timerIsFinished, setTimerIsFinished] = useState(false);
  const [timeElapsed, setTimeElapsed] = useState(0);

  const sendTime = (time) => {
    setTimeElapsed(time);
  };

  const getTimerTimeRef = useRef(null);

  const [leaveGamePopup, setLeaveGamePopup] = useState(false);
  
  const sendLeaveGame = (value) => {
      setLeaveGamePopup(value);
  };

  const wordPairs = [
    { en: "cat", français: "chat", synonymes: "feline", antonymes: "dog", définitions: "Lorem ipsum test bla bla bla truc machin cat" },
    { en: "dog", français: "chien", synonymes: "canine", antonymes: "cat", définitions: "Lorem ipsum test bla bla bla truc machin dog" },
    { en: "house", français: "maison", synonymes: "home", antonymes: "street", définitions: "Lorem ipsum test bla bla bla truc machin house" },
    { en: "book", français: "livre", synonymes: "volume", antonymes: "magazine", définitions: "Lorem ipsum test bla bla bla truc machin book" },
    { en: "apple", français: "pomme", synonymes: "fruit", antonymes: "meat", définitions: "Lorem ipsum test bla bla bla truc machin apple" },
  ];

  const shuffle = (array) => [...array].sort(() => Math.random() - 0.5);
  const uniqueId = (() => {
    let count = 0;
    return () => `id-${count++}`;
  })();

  const baseKey = 'en';
  const [columns, setColumns] = useState([]);
  const [selections, setSelections] = useState({});
  const [matched, setMatched] = useState([]);
  const [feedback, setFeedback] = useState([]);
  const [errorCount, setErrorCount] = useState(0);
  const [showErrorStyle, setShowErrorStyle] = useState(false);

  const [allWords, setAllWords] = useState({});

  useEffect(() => {
    // const keys = Object.keys(wordPairs[0]).filter(k => k !== baseKey);
    // const numberOfExtraColumns = Math.min(level, keys.length);
    // const randomKeys = shuffle(keys).slice(0, numberOfExtraColumns);

    // Récupère les clés disponibles, sauf 'en'
    let keys = Object.keys(wordPairs[0]).filter(k => k !== baseKey);

    // Si level >= 3, on exclut 'def'
    if (level >= 3) {
      keys = keys.filter(k => k !== 'def');
    }

const numberOfExtraColumns = Math.min(level, keys.length);
const randomKeys = shuffle(keys).slice(0, numberOfExtraColumns);

    const baseColumn = {
      label: "Anglais",
      key: baseKey,
      words: shuffle(wordPairs.map(pair => ({
        value: pair[baseKey],
        pairKey: pair[baseKey],
        id: uniqueId(),
      })))
    };

    const extraColumns = randomKeys.map(k => ({
      label: k,
      key: k,
      words: shuffle(wordPairs.map(pair => ({
        value: pair[k],
        pairKey: pair[baseKey],
        id: uniqueId(),
      })))
    }));

    const allCols = [baseColumn, ...extraColumns];
    setColumns(allCols);

    // AJOUTER CECI POUR STOCKER TOUS LES MOTS PAR CLÉ :
    const wordsByKey = {};
    allCols.forEach(col => {
      wordsByKey[col.key] = col.words;
    });
    setAllWords(wordsByKey);
  }, [level]);

  const isMatched = (id) => matched.some(group => Object.values(group.ids).includes(id));

  // const isInFeedback = (id) => {
  //   const item = feedback.find(g => Object.values(g.ids).includes(id));
  //   return item ? (item.success ? "success" : "error") : null;
  // };

  const handleSelect = (colKey, word) => {
    if (isMatched(word.id)) return;

    setSelections(prev => {
      const updated = { ...prev, [colKey]: word };

      // Si toutes les colonnes sont sélectionnées
      if (Object.keys(updated).length === columns.length) {
        const pairKey = updated[baseKey].pairKey;
        const allMatch = Object.values(updated).every(w => w.pairKey === pairKey);

        const ids = Object.fromEntries(columns.map(col => [col.key, updated[col.key].id]));

        if (allMatch) {
          // setMatched(prev => [...prev, { ids, pairKey }]);
          setMatched(prev => {
            const alreadyExists = prev.some(group =>
              JSON.stringify(group.ids) === JSON.stringify(ids)
            );
            if (!alreadyExists) {
              return [...prev, { ids, pairKey }];
            }
            return prev;
          });
          console.log(matched)
        } else {
          setErrorCount(prev => prev + 1);
          console.log('test error')
          setFeedback(prev => [...prev, { ids, success: false }]);
          setShowErrorStyle(true);
          setTimeout(() => {
            setShowErrorStyle(false);
          }, 1000);

          // Supprime le feedback après 1 seconde
          setTimeout(() => {
            setFeedback(prev => prev.filter(f => f.ids[baseKey] !== ids[baseKey]));
          }, 1000);
        }

        return {};
      }

      return updated;
    });
  };

  const getButtonStyle = (id) => {
    if (isMatched(id)) {
      return {
        backgroundColor: "var(--orange)",
        borderColor: "var(--orange)",
        color: "white"
      };
    }

    if (Object.values(selections).some(sel => sel.id === id)) {
      return {
        borderColor: "var(--orange)",
        color: "var(--orange)"
      };
    }

    const isError = feedback.some(f => Object.values(f.ids).includes(id));
    if (isError) {
      return {
        backgroundColor: "#A8AEBE",
        color: "white"
      };
    }

    return {};
  };

  // Handle end of the game if every words have been matched
  // useEffect(() => {
  //   if (!timerIsFinished && matched.length === wordPairs.length) {
  //     setTimerIsFinished(true);
  //   }
  // }, [matched, timerIsFinished, wordPairs.length]);
  useEffect(() => {
  if (!timerIsFinished && matched.length === wordPairs.length) {
    // Récupère d'abord le temps courant depuis le Timer (s'il est disponible)
    if (getTimerTimeRef.current) {
      try {
        const currentTime = getTimerTimeRef.current();
        sendTime(currentTime);
      } catch (e) {
        // sécurité : si la récupération échoue, on ignore et on continue
        console.warn("Impossible de récupérer le temps depuis le Timer :", e);
      }
    }

    // Puis on indique que le timer est fini (cela stoppe le Timer si celui-ci écoute la prop)
    setTimerIsFinished(true);
  }
}, [matched, timerIsFinished, wordPairs.length]);

  const checkErrors = () => {
      if (matched !== wordPairs.length) {
          let errorsToAdd = (wordPairs.length - matched.length)
          setErrorCount((prev) => prev + errorsToAdd);
      }
    }

  return (
    <div className="page-container">
      <Sidebar />
      <div className="content-container inGame" id="wordMatch">
        <div className="title">
          <h4>{theme} - {subTheme}</h4>
          <div className="level-infos">
            <Timer 
              timer={timerIsFinished} 
              onFinish={() => {
                checkErrors()
                setTimerIsFinished(true)
              }} 
              onSendTime={sendTime} 
              onGetTime={(getTimeFn) => getTimerTimeRef.current = getTimeFn}
              hasLimit={false}
            />
          </div>
        </div>

        <div className={`game-container launched level-${level}`}>
          <div className={`game-content ${showErrorStyle ? 'show-error' : ''}`}>
            <h3>Associez les mots entre eux</h3>

            <div className="columns-container">
              <div className="columns-remaining">
                {columns.map(col => {
                  // Mots non appariés
                  const remaining = col.words.filter(w => !isMatched(w.id));

                  // Mots appariés (dans le bon ordre d’origine)
                  const matchedWords = matched
                    .map(pair => {
                      const wordId = pair.ids[col.key];
                      return allWords[col.key].find(w => w.id === wordId);
                    })
                    .filter(Boolean); // au cas où

                  return (
                    <div key={col.key} className="column-type">
                      <h3>{col.label}</h3>
                      <div className="words-container">
                        {remaining.map(word => (
                          <div
                            key={word.id}
                            className="words"
                            style={getButtonStyle(word.id)}
                            onClick={() => handleSelect(col.key, word)}
                          >
                            {word.value}
                          </div>
                        ))}
                        {/* Mots appariés, en bas */}
                        {matchedWords.map(word => (
                          <div
                            key={word.id}
                            className="words matched"
                            style={getButtonStyle(word.id)}
                          >
                            {word.value}
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="wrong-answers" style={{display: "none"}}>
            <h2>Erreurs : {errorCount}</h2>
          </div>
        </div>

        <EndGameBtn onClick={() => {
          if (getTimerTimeRef.current) {
            const currentTime = getTimerTimeRef.current();
            sendTime(currentTime);
          }
          checkErrors();
          setTimerIsFinished(true);
        }} />
      </div>

      <AnimatedBg />
      <GameMenu onSendLeaveGame={sendLeaveGame}/>
      <Popup time={timeElapsed} timerIsFinished={timerIsFinished} errorCount={errorCount}/>
      <LeaveGamePopup popupOpen={leaveGamePopup} onSendLeaveGame={sendLeaveGame} />
    </div>
  );
}